import ConnectButton from './ConnectButton'

export default ConnectButton
